import type { RouteLocationNormalized } from 'vue-router';
import { useRoute } from 'vue-router';
import type { identifier } from '@core/models/base';

export const parseRouteId = (routeId: string | null | (string | null)[]): identifier | null => {
  if (!routeId) return null;
  return typeof routeId === 'string' ? parseInt(routeId, 10) : parseRouteId(routeId[0]);
};

export const useOptionalRouteIds = (...names: string[]): (identifier | null)[] => {
  const route = useRoute();

  return names.map((name) => {
    if (route.params[name]) return parseRouteId(route.params[name]);
    if (route.query[name]) return parseRouteId(route.query[name]);
    return null;
  });
};

export const useRouteIdsFromRoute = (route: RouteLocationNormalized, ...names: string[]): identifier[] => {
  const ids = names.map((name) => {
    if (route.params[name]) return parseRouteId(route.params[name]);
    if (route.query[name]) return parseRouteId(route.query[name]);

    return null;
  });

  if (ids.some((i) => !i)) {
    throw new Error(`Required ${name} but it wasn't found`);
  }
  return ids as identifier[];
};

export const useRouteIds = (...names: string[]): identifier[] => {
  return useRouteIdsFromRoute(useRoute(), ...names);
};
